/**
 * Created by evdokimov on 26.05.2017.
 */
import _ from 'underscore'
import ReportMediator from './ReportMediator'

export default function OldReportMediator() {}

OldReportMediator.prototype = _.create(ReportMediator.prototype, {
    makeServiceParams: function(reportParams)
    {
        return reportParams;
    },

    getDateRangeParameter: function()
    {
        return this.dateRangeSelector.getSelectedRangeJSON();
    },

    setDateRangeParameter: function(reportParameters)
    {
        this.dateRangeSelector.setSelectedRangeJSON(reportParameters);
    },

    _createPrintableDateRangeHeader: function()
    {
        return this.printableHeadersBuilder.addDateRangeHeaderString( this.reportParameters.dateRangeSelection );
    },

    // default date range selector. must be override in concrete child if necessary
    createDateRangeSelector: function(reportParameters)
    {
        const dateRangeSelectorConfig = {
            dateRangeSelection: reportParameters.dateRangeSelection,
            menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems(reportParameters.dateRangeSelection.qualifier),
            callOnChangeCallbackIfInvalid: true
        };

        return new DateRangeSelectorController().init(dateRangeSelectorConfig);
    }
});


// WEBPACK FOOTER //
// ./web/js/reports/OldReportMediator.js